import React, { ComponentPropsWithoutRef } from "react";
import { Stack, Typography } from "@mui/material";
import { EdgeShell } from "../components/SideNav/EdgeShell";

export function PageForbidden({ children }: ComponentPropsWithoutRef<"div">) {
  return (
    <EdgeShell>
      <Stack width={1} height={1} minHeight="50vh" alignItems="center" justifyContent="center">
        <Typography color="primary" variant="h3">
          Forbidden
        </Typography>
        <Typography color="primary" variant="h1" fontWeight="bold">
          403
        </Typography>
      </Stack>
    </EdgeShell>
  );
}
